import { createRequest, RequestConfig } from 'app/common/api';

import { TPersonData } from '../core/person';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_person',
};

export const getPersonRequest = (personId: TPersonData['id']) =>
  createRequest({
    url: config.url,
    method: config.method,
    query: { id: String(personId) },
  });
